/* eslint no-param-reassign: "error"*/
import _ from 'lodash';
import CAClaimExtension from './models/CAClaimExtension';
import CPClaimExtension from './models/CPClaimExtension';
import GeneralClaimExtension from './models/GeneralClaimExtension';
import HOClaimExtension from './models/HOClaimExtension';
import PAClaimExtension from './models/PAClaimExtention';
import WCClaimExtension from './models/WCClaimExtension';
import { getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import appConfig from 'app-config';

export default {
    mixinLobDraftDataExtensions: claim => {
        if (!claim.policy) {
            return;
        }
        claim.lobs = _.isObject(claim.lobs) ? claim.lobs : {};
        const { policyType } = claim.policy;
        switch (policyType) {
            case 'PersonalAuto':
                claim.lobs.personalAuto = new PAClaimExtension(
                    claim,
                    'personalAuto'
                );
                break;
            case 'Homeowners':
            case 'HOPHomeowners':
                claim.lobs.homeowners = new HOClaimExtension(claim);
                break;
            case 'BusinessAuto':
                claim.lobs.commercialAuto = new CAClaimExtension(
                    claim,
                    'commercialAuto'
                );
                break;
            case 'GeneralLiability':
                claim.lobs.generalLiability = new GeneralClaimExtension(
                    claim,
                    'generalLiability'
                );
                break;
            case 'BusinessOwners':
                claim.lobs.businessOwners = new GeneralClaimExtension(
                    claim,
                    'businessOwners'
                );
                break;
            case 'InlandMarine':
                claim.lobs.inlandMarine = new GeneralClaimExtension(
                    claim,
                    'inlandMarine'
                );
                break;
            case 'WorkersComp':
                claim.lobs.workersComp = new WCClaimExtension(claim);
                break;
            case 'CommercialProperty':
                claim.lobs.commercialProperty = new CPClaimExtension(claim);
                break;
            default:
                break;
        }
    },

    setLossDetails: claim => {
        const {policyType} = claim.policy;
        const normalizedLobCode = getNormalizedLOBName(
            policyType
        );
        switch (normalizedLobCode) {
            case 'ho':
                claim.lossType = 'PR';
                break;
            case 'cp':
                claim.lossType = 'PR';
                break;
            default:
                 break;
        }
    },
};
